import { render, staticRenderFns } from "./ManageSuggestion.vue?vue&type=template&id=ab8bbaec"
import script from "./ManageSuggestion.vue?vue&type=script&lang=js"
export * from "./ManageSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports